import { useEffect, useState } from 'react';

function readInitial() {
  if (typeof navigator === 'undefined' || typeof navigator.onLine !== 'boolean') {
    return true;
  }
  return navigator.onLine;
}

/**
 * Returns true while the browser reports an active network connection.
 *
 * Single source of truth for the runtime online/offline state — reacts to the
 * `online`/`offline` DOM events so views can show a non-destructive offline
 * indication (the loaded app stays usable; data re-syncs once back online).
 *
 * Note: this is the *runtime* offline path (connection drops while the app is
 * running). The dedicated full-screen cold-load fallback (OfflineEmptyScreen)
 * belongs to the PWA-Offline work package, not here. See #491.
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(readInitial);

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return isOnline;
}
